<div
  data-testid="status-filter-container"
  class="flex justify-between items-center flex-wrap gap-2"
>
  <!-- Action Buttons -->
  <div data-testid="status-filter-actions" class="flex gap-2">
    @if (secondaryButton && secondaryButton.show !== false) {
      <p-button
        #secondaryBtn
        data-testid="status-filter-secondary-btn"
        (onClick)="onSecondaryButtonClick($event)"
        [severity]="secondaryButton.severity || 'secondary'"
        [outlined]="secondaryButton.outlined !== false"
        [disabled]="secondaryButton.disabled"
        size="small"
        class="secondary-button"
      >
        <div class="flex items-center gap-1">
          <span
            *ngIf="secondaryButton.icon"
            class="material-symbols-outlined"
            >{{ secondaryButton.icon }}</span
          >
          <span *ngIf="secondaryButton.label">{{
            secondaryButton.label | translate
          }}</span>
        </div>
      </p-button>
    }
    @if (primaryButton && primaryButton.show !== false) {
      <p-button
        (onClick)="onprimaryButtonClick($event)"
        [severity]="primaryButton.severity || 'primary'"
        [outlined]="primaryButton.outlined"
        [disabled]="primaryButton.disabled"
        size="small"
        class="primary-button"
        data-testid="status-filter-primary-btn"
      >
        <div class="flex items-center gap-1">
          <span *ngIf="primaryButton.icon" class="material-symbols-outlined">{{
            primaryButton.icon
          }}</span>
          {{ primaryButton.label | translate }}
        </div>
      </p-button>
    }
  </div>
  <p-selectbutton
    data-testid="status-filter-select"
    [options]="statusOptions"
    optionLabel="label"
    optionValue="key"
    [(ngModel)]="activeKey"
    [ngModelOptions]="{ standalone: true }"
    (onChange)="onSelectChange($event.value)"
    class="filter-button"
  >
    <ng-template let-option pTemplate="item">
      <span [attr.data-testid]="'status-filter-option-' + option.key">
        {{ option.label | translate }}
      </span>
    </ng-template>
  </p-selectbutton>
</div>
